import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';
import { PageTypeService } from './page-type.service';
import { PageTypeStore } from './page-type.store';
import { PageTypeQuery } from './page-type.query';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppToken } from "../../../models/app-token";
import { PageTypeModel } from "./page-type.model";
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageTypeFacade extends BaseFacade {

  constructor(
    private readonly pageTypeService: PageTypeService,
    private readonly pageTypeStore: PageTypeStore,
    private readonly pageTypeQuery: PageTypeQuery,
    private readonly dynamicSchemaFactory: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(pageTypeService,
      pageTypeStore,
      pageTypeQuery,
      dynamicSchemaFactory.getDynamicSchemaFacade(AppToken.PAGE_TYPE_SCHEMA_NAME),
      translateService,
      AppToken.PAGE_TYPE_SCHEMA_NAME + '-facade'
      );
  }

  getDefaultPageType(): Observable<PageTypeModel> {
    return this.pageTypeService.getDefaultPageType();
  }

  getPlaceholderPageType(): Observable<PageTypeModel> {
    return this.pageTypeService.getPlaceholderPageType();
  }
}
